import { type TFunction } from 'i18next';
import { type ArticleGroup, type ArticleListDropdownItem } from '@sr/types';

export const HAZARDOUS_ARTICLE_GROUP_CODE = '34';

export const articleGroupsToListDropdown = ({
  articleGroups,
  excludeDeclarations,
  enableHazardDescription = true,
  t,
}: {
  articleGroups: ArticleGroup[];
  excludeDeclarations?: boolean;
  enableHazardDescription?: boolean;
  t: TFunction;
}): ArticleListDropdownItem[] =>
  articleGroups
    .sort((a, b) => a.groupName.localeCompare(b.groupName, 'sv'))
    .map((articleGroup) => ({
      type: 'group',
      value: articleGroup.groupName,
      label: articleGroup.groupName,
      meta: {
        description:
          enableHazardDescription && articleGroup.groupCode === HAZARDOUS_ARTICLE_GROUP_CODE
            ? t('filter.articleGroup.specialDescription')
            : '',
      },
      children: articleGroup.children
        .toSorted((a, b) => a.articleName.localeCompare(b.articleName, 'sv'))
        .map((article) => ({
          value: article.articleCode,
          label: article.articleName,
          meta: {
            description: article.articleCode,
            valueType: 'article',
          },
          type: 'value',
          children: excludeDeclarations
            ? []
            : article.children
                .toSorted((a, b) => a.declarationName.localeCompare(b.declarationName, 'sv'))
                .map((declaration) => ({
                  value: declaration.declarationKey,
                  label: declaration.declarationName,
                  meta: {
                    description: declaration.declarationCode,
                    valueType: 'declaration',
                  },
                  type: 'value',
                  children: [],
                })),
        })),
    }));

export const getArticleCodesFromArticleGroups = (articleGroups: ArticleGroup[]) => {
  return articleGroups.reduce<string[]>((acc, ag) => {
    return [...acc, ...ag.children.flatMap((a) => [a.articleCode])];
  }, []);
};

export const getDeclarationCodesFromArticleGroups = (artcleGroups: ArticleGroup[]) => {
  return artcleGroups.reduce<string[]>((acc, ag) => {
    return [
      ...acc,
      ...ag.children.flatMap((a) =>
        a.children.flatMap((d) => {
          return [d.declarationKey];
        }),
      ),
    ];
  }, []);
};
